import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whatscovered-nav hammodal" }
const _hoisted_2 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_3 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_12 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { style: {"line-height":"22px"} }
const _hoisted_15 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_16 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "whatscovered-bullets"
}
const _hoisted_23 = {
  valign: "top",
  width: "15%",
  class: "whatscovered-icon"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { style: {"line-height":"22px"} }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CoveredModal',
  setup(__props) {

const pageNumber = ref(1);
// This function is not used
// const assurantBookletPath: ComputedRef<string> = computed(() => {
//   return window.location.href + "assets/assurantpolicybooklet.pdf";
// });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        id: "whatscoveredabutton",
        class: _normalizeClass({ active: pageNumber.value == 1 }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (pageNumber.value = 1))
      }, " Property Damage & Personal Liability ", 2),
      _createElementVNode("span", {
        id: "whatscoveredabutton",
        class: _normalizeClass({ active: pageNumber.value == 2 }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (pageNumber.value = 2))
      }, " Personal Property Coverage ", 2)
    ]),
    _createElementVNode("div", {
      class: "whatscoveredwindow",
      style: _normalizeStyle([pageNumber.value == 1 ? { display: 'block' } : { display: 'none' }])
    }, [
      _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Property Damage Liability", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "poweredby-hotspot" }, [
        _createElementVNode("span", { class: "poweredby" }, "Provided by Assurant"),
        _createElementVNode("p", { class: "poweredby-content" }, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is used to associate their products and services, and to connect with the brand of their parent company, Assurant, Inc. ")
      ], -1)),
      _cache[11] || (_cache[11] = _createElementVNode("p", null, " Property Damage Liability insurance covers damages to your college dorm, landlord's apartment, or your neighbor's property when you are at fault. ", -1)),
      _cache[12] || (_cache[12] = _createElementVNode("p", null, " Property covered under this policy would be items the rental unit came with (e.g. stove, fridge, sink, toilet) or the building itself. ", -1)),
      _cache[13] || (_cache[13] = _createElementVNode("p", null, " If you are liable for damages, renters insurance can help save you the stress of having to pay out-of-pocket. When a covered incident happens, all you have to take care of is a small deductible – we’ll cover the Rest Rest easy and have peace of mind. ", -1)),
      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
      _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
      _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
      _cache[17] || (_cache[17] = _createElementVNode("h5", null, "Incidents Covered", -1)),
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon1.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_4)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Fire"),
              _createElementVNode("br"),
              _createTextVNode("Like a grease fire resulting in damage to to the kitchen counters and appliances. ")
            ], -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon10.svg'),
                alt: "Water Flood"
              }, null, 8, _hoisted_6)
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Water *"),
              _createElementVNode("br"),
              _createTextVNode("Left the sink on? We’ll cover damage to the floor & the neighbor’s items on the floor below you. "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "*In North Carolina, water damage liability is optional for renters insurance.")
            ], -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_7, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon11.svg'),
                alt: "Smoke Damage"
              }, null, 8, _hoisted_8)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Smoke"),
              _createElementVNode("br"),
              _createTextVNode("Leaving candles unattended may result in in smoke damage. ")
            ], -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_9, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon12.svg'),
                alt: "Explosion"
              }, null, 8, _hoisted_10)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Explosion"),
              _createElementVNode("br"),
              _createTextVNode("Science experiment gone wrong? We’ll We’ll cover the damage! ")
            ], -1))
          ])
        ])
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
      _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1)),
      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
      _cache[21] || (_cache[21] = _createElementVNode("h5", null, "Includes Personal Liability", -1)),
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon2.svg'),
                alt: "Personal Injury Renters Insurance"
              }, null, 8, _hoisted_13)
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("td", null, " If a guest gets injured, the insurer will cover the necessary medical and legal expenses. ", -1))
          ])
        ])
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
      _cache[23] || (_cache[23] = _createElementVNode("hr", null, null, -1)),
      _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("p", null, [
        _createElementVNode("small", _hoisted_14, [
          _cache[8] || (_cache[8] = _createTextVNode(" See your proof of insurance booklet (provided after purchase) to view complete coverage details including limitations and exclusions (terms and conditions). Coverages vary by state. ", -1)),
          _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Assurant underwriter", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ], 4),
    _createElementVNode("div", {
      class: "whatscoveredwindow",
      style: _normalizeStyle([pageNumber.value == 2 ? { display: 'block' } : { display: 'none' }])
    }, [
      _cache[31] || (_cache[31] = _createElementVNode("h4", null, "Personal Property Coverage", -1)),
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "poweredby-hotspot" }, [
        _createElementVNode("span", { class: "poweredby" }, "Provided by Assurant"),
        _createElementVNode("p", { class: "poweredby-content" }, " In all states, unless otherwise noted, Renters Insurance is underwritten by American Bankers Insurance Company of Florida with its home office in Miami, Florida. In Minnesota, the underwriter is American Security Insurance company. In Georgia, Residents Liability is underwritten by Voyager Indemnity Insurance Company. In Utah, coverage is provided under policy form AJ8850PC-0307 or AJ9281CKK-0609. The trade name Assurant is used to associate their products and services, and to connect with the brand of their parent company, Assurant, Inc. ")
      ], -1)),
      _cache[33] || (_cache[33] = _createElementVNode("p", null, " Personal Property Coverage will cover your TV, furniture, small appliances, bike, guitar, classroom materials, and more! Think about how much it would cost to replace all your belongings if there was a fire, water damage, or burglary in your dorm. You will be reimbursed for what it it costs to repair or replace your things. ", -1)),
      _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
      _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
      _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
      _cache[37] || (_cache[37] = _createElementVNode("h5", null, "Incidents Covered", -1)),
      _createElementVNode("table", _hoisted_15, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_16, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon15.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_17)
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Theft & Vandalism"),
              _createElementVNode("br"),
              _createTextVNode(" Was your gaming system stolen? We’ll make sure you have a replacement in no time! ")
            ], -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon1.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_19)
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Fire, Water Damage & Other Covered Perils"),
              _createElementVNode("br"),
              _createTextVNode(" Did your apartment get flooded? Get reimbursed for items that got destroyed. ")
            ], -1))
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_20, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon14.svg'),
                alt: "Fire"
              }, null, 8, _hoisted_21)
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("td", { valign: "top" }, [
              _createElementVNode("strong", null, "Power Surge By Lightning"),
              _createElementVNode("br"),
              _createTextVNode(" Computer not working after a storm? We will help you get it repaired! ")
            ], -1))
          ])
        ])
      ]),
      _cache[38] || (_cache[38] = _createElementVNode("div", { style: {"padding":"20px 0px","color":"#777","letter-styling":"italics"} }, [
        _createElementVNode("small", null, "Also Covered: Smoke, Explosion, Windstorm, Hail, Ice, Snow, Sleet, Pipe Pipe Bursts, Cracked AC, Water/Heating System, Freezing, Volcanic Eruption ")
      ], -1)),
      _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
      _cache[40] || (_cache[40] = _createElementVNode("hr", null, null, -1)),
      _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
      _cache[42] || (_cache[42] = _createElementVNode("h5", null, "Items covered", -1)),
      _createElementVNode("table", _hoisted_22, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_23, [
              _createElementVNode("img", {
                src: require('@/assets/images/icon13.svg'),
                alt: "Items Covered"
              }, null, 8, _hoisted_24)
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("td", null, " Laptops, Tablets, Cell Phones, TVs, Blu-ray Players, Game Consoles, Consoles, Cameras, Clothing, Jewelry, Sports Equipment, Musical Instruments, Books, Furniture, Appliances and more. ", -1))
          ])
        ])
      ]),
      _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
      _cache[44] || (_cache[44] = _createElementVNode("hr", null, null, -1)),
      _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("p", null, [
        _createElementVNode("small", _hoisted_25, [
          _cache[30] || (_cache[30] = _createTextVNode(" See your proof of insurance booklet (provided after purchase) to view complete coverage details including limitations and exclusions (terms and conditions). Coverages vary by state. ", -1)),
          _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
              _createTextVNode("Assurant underwriter", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ], 4)
  ], 64))
}
}

})